export default "__VITE_ASSET__3KIlmHQ3__"